import React from "react"
import { Link } from "gatsby"
import videojs from "video.js"
import CallAction from "../Button/Cta"
import "../../../node_modules/video.js/dist/video-js.min.css"
import "videojs-youtube"
import "./mvVideoStyle.css"
import { Actions, Categories, Events } from "../GaEvents"

class MVVideoPlayer extends React.Component {
  constructor(props) {
    super(props)

    this.player = {}
  }

  componentDidMount() {
    const {
      source,
      type,
      autoPlay,
      controls,
      onUserInactive,
      onUserActive,
      onVideoEnd,
      trackingName,
      poster,
    } = this.props

    const videoJsOptions = {
      autoplay: autoPlay,
      controls,
      bigPlayButton: false,
      controlBar: {
        volumePanel: { inline: false, vertical: true },
      },
      sources: [
        {
          type,
          src: source,
        },
      ],
      youtube: {
        iv_load_policy: 1,
        controls: 0,
        showinfo: 0,
      },
      preload: "none",
    }

    this.player = videojs(this.videoNode, videoJsOptions, () => {
      const playerMarkers = []

      this.player.on("userinactive", () => {
        const { isEnd } = this.state
        onUserInactive(isEnd)
      })

      this.player.on("useractive", () => {
        onUserActive()
      })

      this.player.on("play", () => {
        if (
          typeof window !== "undefined" &&
          typeof window.dataLayer !== "undefined"
        ) {
          let action = Actions.VideoResume
          if (parseInt((this.currentTime && this.currentTime()) || 0, 10) < 2) {
            action = Actions.VideoPlay
          }

          this.eventToDataLayer(
            action,
            trackingName,
            (this.currentTime && this.currentTime()) || 0
          )
        }
      })

      this.player.on("play", (event) => {
        this.eventToDataLayer(
          Actions.VideoPause,
          trackingName,
          (this.currentTime && this.currentTime()) || 0
        )
      })

      this.player.on("seeked", () => {
        this.setState({ isEnd: false })
      })

      this.player.on("seeking", () => {
        this.eventToDataLayer(
          Actions.VideoTimelineJump,
          trackingName,
          (this.currentTime && this.currentTime()) || 0
        )
      })

      this.player.on("error", (error) => {
        this.eventToDataLayer(Actions.VideoError, trackingName, error)
      })

      this.player.on("ended", (event) => {
        this.setState({ isEnd: true })
        onVideoEnd()
        this.player.exitFullscreen()

        this.eventToDataLayer(
          Actions.VideoEnded,
          trackingName,
          (this.currentTime && this.currentTime()) || 0
        )
      })

      this.player.on("timeupdate", () => {
        const percentPlayed =
          this.duration && this.currentTime
            ? Math.floor(
                (this.currentTime && this.currentTime() * 100) / this.duration()
              )
            : 0

        const markers = [5, 10, 15, 20, 25, 50, 75, 100]

        if (
          markers.find((marker) => marker === percentPlayed) &&
          !playerMarkers.find((marker) => marker === percentPlayed)
        ) {
          playerMarkers.push(percentPlayed)
          this.eventToDataLayer(
            `${percentPlayed}%`,
            trackingName,
            this.currentTime()
          )
        }
      })
    })
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  eventToDataLayer(eventAction, eventLabel, videoCurrentTime) {
    if (
      typeof window !== "undefined" &&
      typeof window.dataLayer !== "undefined"
    ) {
      window.dataLayer.push({
        event: Events.Video,
        eventCategory: Categories.VideoJS,
        eventAction,
        eventLabel,
        videoCurrentTime,
      })
    }
  }

  render() {
    const { endScreen } = this.props
    let cta

    if (endScreen && endScreen.cta.link) {
      cta = (
        <Link to={endScreen.cta.link}>
          <CallAction>{endScreen.cta.label}</CallAction>
        </Link>
      )
    } else if (endScreen && endScreen.cta.modalType) {
      cta = (
        <CallAction onClick={this.openLeadFormModal}>
          {endScreen.cta.label}
        </CallAction>
      )
    }

    return (
      <div className="mvVideoContainer">
        <div data-vjs-player>
          <video
            ref={(node) => {
              this.videoNode = node
            }}
            className="video-js vjs-16-9"
          >
            {" "}
          </video>
        </div>
      </div>
    )
  }
}

export default MVVideoPlayer
